module.exports = __webpack_public_path__ + "static/media/mind-share.3a574700.svg";